import { useEffect, useState } from "react";

export const BLOG_PREVIEW_SLUG = "__preview__";
export const BLOG_PREVIEW_MESSAGE = "rhm-blog-preview";

/** The public article page listens for the CRM's unsaved post draft. */
export const useBlogPreview = () => {
    const isPreview = typeof window !== "undefined"
        && new URLSearchParams(window.location.search).get("preview") === "1";
    const [draft, setDraft] = useState(null);

    useEffect(() => {
        if (!isPreview) return undefined;
        const onMessage = (event) => {
            if (event.data?.type === BLOG_PREVIEW_MESSAGE) setDraft(event.data.payload || null);
        };
        window.addEventListener("message", onMessage);
        window.parent?.postMessage({ type: `${BLOG_PREVIEW_MESSAGE}-ready` }, "*");
        return () => window.removeEventListener("message", onMessage);
    }, [isPreview]);

    return { isPreview, draft };
};
